"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountStore = void 0;
const common_1 = require("../common");
const base_1 = require("./base");
class AccountStore extends common_1.HasMapStore {
    constructor(eventListener, chainGetter, storeOptsCreator, ...accountSetCreators) {
        super((chainId) => {
            const accountSetBase = new base_1.AccountSetBaseSuper(eventListener, chainGetter, chainId, storeOptsCreator(chainId));
            return common_1.mergeStores(accountSetBase, [this.chainGetter, chainId], ...this.accountSetCreators);
        });
        this.eventListener = eventListener;
        this.chainGetter = chainGetter;
        this.storeOptsCreator = storeOptsCreator;
        this.accountSetCreators = accountSetCreators;
    }
    getAccount(chainId) {
        return this.get(chainId);
    }
    hasAccount(chainId) {
        return this.has(chainId);
    }
}
exports.AccountStore = AccountStore;
//# sourceMappingURL=store.js.map